import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Spacer = styled.div`
  ${({ direction }) => (direction === 'vertical' ? 'width: 100%;' : 'height: 1px; float: left; display: inline-block;')};
  padding-top: ${({ theme, size, direction }) => (direction === 'vertical' ? theme.spacing[size] : 0)};
  padding-left: ${({ theme, size, direction }) => (direction === 'horizontal' ? theme.spacing[size] : 0)};
`;

const SpacerComponent = ({ size, direction }) => (
  <Spacer size={size} direction={direction} />
);

SpacerComponent.propTypes = {
  size: PropTypes.oneOf(['verySmall', 'small', 'regular', 'large', 'veryLarge', 'huge', 'massive', 'superMassive']).isRequired,
  direction: PropTypes.oneOf(['vertical', 'horizontal']),
};

SpacerComponent.defaultProps = {
  direction: 'vertical',
};

export default SpacerComponent;
